import { z } from 'zod'

import { generateRandomString } from '@mntn-dev/utilities'
import type { ZodInfer } from '@mntn-dev/utility-types'

export const ChargeIdSchema = z.string().brand<'charge-id'>()

export type ChargeId = ZodInfer<typeof ChargeIdSchema>

export const ChargeId = (value: string = generateRandomString()) => {
  return ChargeIdSchema.parse(value)
}
